import { teamsCore } from '@microsoft/teams-js';
import { reportError, reportInfo } from '@ms/yammer-telemetry';
import { isAppInitialized } from '@ms/yammer-web-support/dist/metaOsHub';
import type { YammerTeamsNativeState } from 'state/types';

import { handleBeforeUnloadApp } from './handleBeforeUnloadApp';
import { handleOnLoadAppFromCache } from './handleOnLoadAppFromCache';

let storeGetState: (() => YammerTeamsNativeState) | null = null;

export const registerTabCaching = (): void => {
  try {
    if (!isAppInitialized()) {
      return;
    }

    teamsCore.registerBeforeUnloadHandler((readyToUnload) => {
      reportInfo({
        eventName: 'teams_before_unload_handler_invoked',
      });

      if (!storeGetState) {
        reportError({
          error: new Error('Store not available for BeforeUnloadHandler'),
          eventProperties: {
            errorCode: 'TeamsTabCachingStoreNotAvailable',
          },
        });
      }

      return handleBeforeUnloadApp(readyToUnload);
    });

    teamsCore.registerOnLoadHandler(async (appLoadContext) => {
      reportInfo({
        eventName: 'teams_onload_handler_invoked',
      });

      if (!storeGetState) {
        reportError({
          error: new Error('Store not available for OnLoadHandler'),
          eventProperties: {
            errorCode: 'TeamsTabCachingStoreNotAvailable',
          },
        });

        return;
      }

      await handleOnLoadAppFromCache(appLoadContext, storeGetState);
    });

    reportInfo({
      eventName: 'teams_tab_caching_registered',
    });
  } catch (error: unknown) {
    reportError({
      error,
      eventProperties: {
        errorCode: 'TeamsTabCachingRegistrationFailed',
      },
    });
  }
};

export const provideStoreForTabCaching = (getState: () => YammerTeamsNativeState): void => {
  storeGetState = getState;
};
